import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Home from '@/components/Home'
import News from '@/components/News'

import jQuery from 'jquery'

Vue.use(Router)

export default new Router({
    routes: [
        /*{
            path: '/hello',
            name: 'Hello',
            component: Hello
        },*/
        {
            path: '/',
            name: 'Home',
            jQuery,
            component: Home
        },
        /*{
            path: '/news',
            name: 'News',
            component: News
        }*/
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js